module.exports = __webpack_public_path__ + "static/media/Molly Weasley 1.08979b40.jpg";